import { useQuery } from "@tanstack/react-query";
import { http } from "../api/http";
import { useAuthStore } from "../store/auth";
export type TeamReference = { entityType: string; entityId: string };
export function TeamReferences({
  references,
  onOpen,
}: {
  references: TeamReference[];
  onOpen: (kind: "notes" | "meetings" | "boards", id: string) => void;
}) {
  const user = useAuthStore((s) => s.user);
  const q = useQuery({
    queryKey: ["team-references", user?.id, references],
    queryFn: async () =>
      (
        await http.post<{
          items: (TeamReference & { available: boolean; label?: string })[];
        }>("/v1/workspace/references/resolve", {
          references: references.map(({ entityType, entityId }) => ({
            entityType,
            entityId,
          })),
        })
      ).data,
    enabled: references.length > 0,
    gcTime: 0,
    refetchInterval: 10000,
    retry: false,
  });
  if (!references.length) return null;
  const kinds: Record<string, "notes" | "meetings" | "boards"> = {
    NOTE: "notes",
    MEETING: "meetings",
    BOARD: "boards",
  };
  return (
    <section aria-label="Objets liés">
      <h3 className="font-semibold">Objets liés</h3>
      {q.isError ? (
        <p>Vérification indisponible.</p>
      ) : q.isFetching ? (
        <p>Vérification…</p>
      ) : (
        q.data?.items?.map((r) => (
          <p key={r.entityType + r.entityId}>
            {r.available && kinds[r.entityType] ? (
              <button
                className="text-indigo-600 underline"
                onClick={() => onOpen(kinds[r.entityType], r.entityId)}
              >
                [{r.label}]
              </button>
            ) : (
              "Dossier indisponible ou non autorisé"
            )}
          </p>
        ))
      )}
    </section>
  );
}
